import React, { Component } from 'react';

// import Immutable from 'immutable';
// import { connect } from 'react-redux';
// import config from 'config/api'
import clsx from 'clsx';
// import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

// import BlockTitle  from 'components/UI/BlockTitle';

import HelpSpeedTest from 'components/Help/HelpSpeedTest';
import Typography from '@material-ui/core/Typography';
import IconUp from '@material-ui/icons/KeyboardArrowUp';
import IconDown from '@material-ui/icons/KeyboardArrowDown';

// import {
// fetchData,
// getDataHome,
// getLoadingError,
// } from '../../ducks/asyncFetcher';

// import {
// isLoggedIn,
// getCurrentUserRole,
// } from 'ducks/authentication';

import { primaryColor } from 'helpers/colors';

// const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      padding: '0 0 50px 0',
      margin: '60px 0',
    },
    wrapper: {
      backgroundColor: theme.palette.primary.main,
      padding: '50px 0 30px 0',
    },
    title: {
      color: theme.palette.text.light,
      marginBottom: 30,
      // marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px',
      },
    },
    moreWrapper: {
      marginTop: 30,
    },
    moreToggler: {
      marginTop: 30,
    },
    link: {
      textDecoration: 'none',
      color: primaryColor,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    hidden: {
      display: 'none',
    },
    more: {
      maxWidth: 600,
      margin: '0 auto 20px',
      color: primaryColor,
      textAlign: 'left',
    },
    speedTest: {
      padding: '20px 0',
    },
    iconStyle: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginTop: '-3px',
    },
  };
};

class LiveHelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this._toggleMore = this._toggleMore.bind(this);
  }
  _toggleMore(e) {
    e.preventDefault();
    const cur = this.state.visible;
    this.setState({ visible: cur === true ? false : true });
  }
  render() {
    const { visible } = this.state;
    const { classes, style } = this.props;

    return (
      <div className={clsx('HomeBlock', 'fullWidth', classes.root)} style={style}>
        <Box align="center" color="common.white">
          <div className={classes.wrapper}>
            <Typography variant={'h5'} className={classes.title}>
              Comment bien visualiser votre live ?
            </Typography>
            <HelpSpeedTest variant="white" />
          </div>
          <div
            className={clsx(classes.moreToggler, {
              [classes.hidden]: visible === true,
            })}
          >
            <a className={classes.link} onClick={this._toggleMore}>
              Voir les autres conditions de visualisation <IconDown className={classes.iconStyle} />
            </a>
          </div>
          <div
            className={clsx(classes.moreWrapper, {
              [classes.hidden]: visible !== true,
            })}
          >
            <ul className={classes.more}>
              <li>Utilisez un ordinateur.</li>
              <li>Privilégiez les navigateurs Mozilla Firefox ou Google Chrome.</li>
              <li>
                Si vous n'entendez pas bien, votre débit de bande passante peut être insuffisant, veuillez
                «figer» le flux vidéo de l'orateur (en cliquant sur l'icône de la caméra sous la vidéo). Vous
                pouvez aussi fermer vos applications (Skype®, YouTube®, Facebook®, Outlook®...).
              </li>
              <li>Connectez-vous à Internet en filaire plutôt qu'en wifi.</li>
            </ul>
            <a className={classes.link} onClick={this._toggleMore}>
              Fermer <IconUp className={classes.iconStyle} />
            </a>
          </div>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles)(LiveHelp);



// WEBPACK FOOTER //
// ./src/components/Lives/LiveHelp.jsx